import React from 'react';

const faqs = [
  {
    question: "What makes good HTML code?",
    answer: "Good HTML code is semantic, accessible, well-structured, and follows web standards. It should use appropriate tags, include proper meta information, and be easily maintainable."
  },
  {
    question: "How does the AI generate HTML?",
    answer: "Our AI analyzes best practices, common patterns, and web standards to generate clean, semantic HTML code. It considers factors like accessibility, SEO, and modern web development practices."
  },
  {
    question: "Can I customize the generated code?",
    answer: "Yes! The generated HTML is fully customizable. You can modify the structure, add your own classes, and adjust the content to match your specific needs."
  },
  {
    question: "Is the generated code responsive?",
    answer: "Yes, our generated layouts and components are designed with responsiveness in mind, ensuring they work well across different screen sizes and devices."
  },
  {
    question: "Does it follow accessibility standards?",
    answer: "Yes, all generated code follows WCAG guidelines and includes proper ARIA attributes where necessary, ensuring your content is accessible to all users."
  },
  {
    question: "How often is the generator updated?",
    answer: "Our AI system continuously learns from current web development trends and best practices to provide up-to-date, modern HTML code that follows the latest standards and conventions."
  }
];

export default function HTMLFAQ() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          HTML Generator FAQ
        </h2>
        
        <div className="space-y-8">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-blue-50 p-6 rounded-lg transform transition-all duration-300 hover:scale-[1.02]">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}